/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-22 23:20:39
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

async function getQrcode (url) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _getQrcode(url).then((res) => {
          resolve(res.data.data)
        })
      })
    })
  })
}

/**
 * 为自己砍价
 */
function _getQrcode (url) {
  const activityInfUrl = `/v1/front/qrcode`
  return axios({
    method: 'POST',
    url: activityInfUrl,
    data: {
      text: url
    }
  })
}

export {getQrcode}



// WEBPACK FOOTER //
// ./src/api/getQrcode.js